<template>
    <system-tabs :tabs="tabs">
        <template slot="help">
            <helpTable/>
            <helpInventory/>
        </template>

        <template slot="w1">
            <InterfaceTable @search="onSearch" @update="onUpdate" :headers="table.headers" :data="table.data" with-index/>
        </template>

        <template slot="w2">
            <InterfaceInventory ref="inventory" @send="onComplete" :title="inventory.title" :image="inventory.image" :table="inventory.table"/>
            <v-dialog v-model="dialog" width="500">
                <v-card>
                    <v-card-text>Данные успешно внесены в программу!</v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialog = false">Закрыть</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </system-tabs>
</template>

<script>
    import InterfaceTable from '@/components/interface/table'
    import InterfaceInventory from '@/components/interface/inventory'
    import SystemTabs from '@/components/system/tabs'

    import helpInventory from '@/components/interface/inventory/help'
    import helpTable from '@/components/interface/table/help'

    import data from './_data.json'

    export default {
        components: {
            InterfaceTable,
            InterfaceInventory,
            SystemTabs,
            helpInventory,
            helpTable
        },
        data () {
            return {
                actions: {
                    success: false,
                    sorted: false,
                    search: false
                },
                complete: false,
                dialog: false,
                tabs: [
                    {
                        title: 'Фильмы в наличии',
                        name: 'table',
                        slot: 'w1'
                    },
                    {
                        title: 'Программа инвентаризации',
                        name: 'inventory',
                        slot: 'w2'
                    }
                ],
                table: data.table,
                inventory: data.inventory
            }
        },
        methods: {
            onComplete (result) {
                let data = {
                    useSort: this.actions.sorted,
                    useSearch: this.actions.search,
                    success: result.result.total === '28'
                }

                if (this.complete) {
                    this.$refs.inventory.reset()
                    return
                }

                this.$store.dispatch('questions/answer', data)
                this.complete = true
                this.dialog = true
                this.$refs.inventory.reset()
            },
            onSearch (text) {
                let result = false
                if (text && text.length > 2) {
                    let regexp = new RegExp(text, 'i')
                    if ('комедия'.search(regexp) > -1) {
                        result = true
                    }
                }
                this.actions.search = result
            },
            onUpdate (data) {
                if (data.sortBy === 'genre') {
                    this.actions.sorted = true
                }
            },

            // Завершение теста
            // Выполнение необходимых действий перед
            // переходом к следующему заданию / этипу
            finish () {}
        }
        // watch: {
        //     genre (val) {
        //         console.log('watch genre', val)
        //     }
        // }
    }
</script>
